import { useState } from 'react';
import {
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  Paper,
} from '@mui/material';
import axios from 'axios';
import logo from './assets/ZVENTURES-Logo-2.png'; // ✅ Import your logo

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async () => {
    try {
      const res = await axios.post('https://attend.zventures.in/api/login', { username, password });
      onLogin(res.data.token, { role: res.data.role, location: res.data.location });
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(to right, #c9d6ff, #e2e2e2)',
        p: 2,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 5,
          width: '100%',
          maxWidth: 400,
          borderRadius: 3,
          backgroundColor: '#ffffffdd',
          backdropFilter: 'blur(6px)',
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <img src={logo} alt="Company Logo" style={{ height: 60, marginBottom: 35, justifySelf:'center' }} />
          <Typography variant="h6" fontWeight="bold" mt={1}>
            Staff Bus Onboarding Tracker
          </Typography>
          <Typography variant="subtitle2" color="text.secondary">
            Please login to continue
          </Typography>
        </Box>

        <TextField
          label="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          margin="normal"
        />

        {error && (
          <Alert severity="error" sx={{ mt: 2, mb: 1 }}>
            {error}
          </Alert>
        )}

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleLogin}
          sx={{ mt: 2, textTransform: 'none' }}
        >
          Login
        </Button>
      </Paper>
    </Box>
  );
};

export default Login;